module.exports = __webpack_public_path__ + "img/3.57f687e9.jpg";